import {inject, observer} from 'mobx-react';

import Container from './commentInput';

function initCommentInputContainer() {
  //  let r:any = inject((rootStore: any) => ({
  //   demoStore: rootStore.demoStore,
  // }))(observer(ContainerInjectedMobx));
  const Clone = class CloneClass extends Container {};
  const r: any = inject((stores: any) => ({
    commentInputStore: stores.rootStore.commentInputStore,
  }))(observer(Clone));
  (r as any).nameOfClass = 'CommentInput';
  return r;

}

export default initCommentInputContainer;
